import DigitalAddress from './DigitalAddress'
import PostalAddress from './PostalAddress'
import TelecomsAddress from './TelecomsAddress'

export default class CustomerAddresses {
  public telecomsAddresses: TelecomsAddress[] = []
  public postalAddresses: PostalAddress[] = []
  public digitalAddresses: DigitalAddress[] = []
}
